var AdminRole;
(function (AdminRole) {
    AdminRole["SUBSCRIPTIONS_CREATE"] = "SUBSCRIPTIONS_CREATE";
    AdminRole["SUBSCRIPTIONS_READ"] = "SUBSCRIPTIONS_READ";
    AdminRole["SUBSCRIPTIONS_UPDATE"] = "SUBSCRIPTIONS_UPDATE";
    AdminRole["SUBSCRIPTIONS_DELETE"] = "SUBSCRIPTIONS_DELETE";
    AdminRole["PLANS_CREATE"] = "PLANS_CREATE";
    AdminRole["PLANS_READ"] = "PLANS_READ";
    AdminRole["PLANS_UPDATE"] = "PLANS_UPDATE";
    AdminRole["PLANS_DELETE"] = "PLANS_DELETE";
    AdminRole["CUSTOMER_SELECT"] = "CUSTOMER_SELECT";
    AdminRole["CUSTOMERS_LIST"] = "CUSTOMERS_LIST";
    AdminRole["CUSTOMER_READ"] = "CUSTOMER_READ";
    AdminRole["CUSTOMER_CREATE"] = "CUSTOMER_CREATE";
    AdminRole["CUSTOMER_UPDATE"] = "CUSTOMER_UPDATE";
    AdminRole["CUSTOMER_DELETE"] = "CUSTOMER_DELETE";
    AdminRole["USER_CUSTOMER_AUTHORIZE"] = "USER_CUSTOMER_AUTHORIZE";
    AdminRole["USERS_LIST"] = "USERS_LIST";
    AdminRole["USER_READ"] = "USER_READ";
    AdminRole["USER_CREATE"] = "USER_CREATE";
    AdminRole["USER_UPDATE"] = "USER_UPDATE";
    AdminRole["USER_DELETE"] = "USER_DELETE";
})(AdminRole || (AdminRole = {}));
export default AdminRole;
